export const COMMUNITY_CATEGORY_NAME = 'Community';
